var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizeCodeTabIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5002L14.1667 6.3335M14.1667 6.3335H11.0417M14.1667 6.3335V9.4585",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.4998L5.83333 14.6665M5.83333 14.6665H8.95833M5.83333 14.6665V11.5415",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 10.4998C1.66699 6.57147 1.66699 4.60728 2.88738 3.38689C4.10777 2.1665 6.07195 2.1665 10.0003 2.1665C13.9287 2.1665 15.8929 2.1665 17.1133 3.38689C18.3337 4.60728 18.3337 6.57147 18.3337 10.4998C18.3337 14.4282 18.3337 16.3924 17.1133 17.6128C15.8929 18.8332 13.9287 18.8332 10.0003 18.8332C6.07195 18.8332 4.10777 18.8332 2.88738 17.6128C1.66699 16.3924 1.66699 14.4282 1.66699 10.4998Z",
    stroke: "#313131",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeCodeTabIcon);
export default __webpack_public_path__ + "static/media/SizeCodeTabIcon.ad0fcc8aac05ed9ab36d9380ed4a97c8.svg";
export { ForwardRef as ReactComponent };